import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { clientTheme } from '@/client/theme';
import { createRoutes } from '@/routes';
import { Suspense, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import ScrollToTop from '@/components/ScrollToTop';
import { LoadingSpinner } from '@/components/LoadingSpinner';
import { logEnvironmentInfo } from '@/config/env';

import { AuthProvider } from '@/lib/sdk/auth/context';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1
    }
  }
})

const AppRoutes = () => {
  const routes = createRoutes();
  return useRoutes(routes);
};

function App() {
  // Log environment info on mount
  useEffect(() => {
    logEnvironmentInfo();
  }, []);

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
      <AuthProvider>
          <ScrollToTop />
          <ChakraProvider theme={clientTheme}>
            <Sentry.ErrorBoundary fallback={<div data-testid="app-error-boundary">Something went wrong. Please refresh the page.</div>}>
              <Suspense fallback={<LoadingSpinner />}>
                <AppRoutes />
              </Suspense>
            </Sentry.ErrorBoundary>
          </ChakraProvider>
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;